import { LogLevel } from './levels';
import { LogEntryMeta } from './logEntry';

/**
 * LoggerEnvironment is an enum of application environments available.
 */
enum LoggerEnvironment {
  DEVELOPMENT = 'development',
  TEST = 'test',
  QA = 'qa',
  STAGING = 'staging',
  PRODUCTION = 'production',
  UNKNOWN = 'unknown',
}

/**
 * BaseLoggerConfig defines the required parameters needs to create
 * any logger instance.
 */
type BaseLoggerConfig = {
  environment: LoggerEnvironment;
  service: string;
  level: LogLevel;
  defaultMeta?: LogEntryMeta;
};

/**
 * LoggerConfig is a helper type to add BaseLoggerConfig inferences to the code.
 */
type LoggerConfig<T extends BaseLoggerConfig> = T;

export type { BaseLoggerConfig, LoggerConfig };
export { LoggerEnvironment };
